import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import WowInit from "../../components/wowInit/wowInit";

// ✅ Home Pages
import Homepage from "../HomePage";
import HomePage2 from "../HomePage2/HomePage2";
import HomePage3 from "../HomePage3/HomePage3";
import AboutPage from "../AboutPage/AboutPage";
import ServicePage from "../ServicePage/ServicePage";
import SeviceSinglePage from "../SeviceSinglePage/SeviceSinglePage";
import CareerSection from "../CareerSection/CareerSection";
import CareerDetails from "../CareerDetails/CareerDetails";
import ProjectPage from "../ProjectPage/ProjectPage";
import ProjectDetails from "../ProjectDetails/ProjectDetails";
import TeamPage from "../TeamPage/TeamPage";
import ScrollToTop from "./ScrollToTop";
import BlogPage from "../BlogPage/BlogPage";
import BlogDetails from "../BlogDetails/BlogDetails";
import ErrorPage from "../ErrorPage/ErrorPage";
import CompanyPage from "../CompanyPage/CompanyPage";
import ProductShowcase from "../ProductShowcase/ProductShowcase";
import CompanyHome from "../CompanySite/CompanyHome";
import { siteConfig } from "../../siteConfig";
import { getEntity } from "../../data/companies";

// ✅ Router Component
const AllRoute: React.FC = () => {
  // ============================================================
  // COMPANY SITE MODE — jab ye build kisi company ki alag site ho
  // (siteConfig.entitySlug set) to "/" par us company ka home render
  // hota hai; baqi saare routes (About/Contact/Programs...) same rehte
  // hain taake main site wala navbar har jagah kaam kare.
  // ============================================================
  const entity = siteConfig.entitySlug
    ? getEntity(siteConfig.entitySlug)
    : undefined;

  const homeElement = entity ? (
    <CompanyHome entity={entity} />
  ) : (
    <Homepage />
  );

  return (
    <div className="App">
      <BrowserRouter>
        <WowInit />
        <ScrollToTop />

        <Routes>
          {/* ✅ Home Routes */}
          <Route path="/" element={homeElement} />
          <Route path="/home" element={homeElement} />
          <Route path="/ai-marketing" element={<HomePage2 />} />
          <Route path="/ai-chatbot" element={<HomePage3 />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/service" element={<ServicePage />} />
          <Route path="/service-details" element={<SeviceSinglePage />} />
          <Route path="/career" element={<CareerSection />} />
          <Route path="/career-details" element={<CareerDetails />} />
          <Route path="/project" element={<ProjectPage />} />
          <Route path="/project-details" element={<ProjectDetails />} />
          <Route path="/team" element={<TeamPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog-details" element={<BlogDetails />} />
          {/* Contact page removed — landing page ke contact section par redirect */}
          <Route path="/contact" element={<Navigate to="/#contact" replace />} />
          {/* ✅ KOT Corporate Companies & Strategic Programs */}
          <Route path="/companies/:slug" element={<CompanyPage />} />
          <Route path="/programs/:slug" element={<CompanyPage />} />
          {/* ✅ KOT Showcase Products (Our Work) */}
          <Route path="/work/:slug" element={<ProductShowcase />} />
          {/* ✅ Error Page */}
          <Route path="/404" element={<ErrorPage />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default AllRoute;
